import { render, staticRenderFns } from "./products-edit.vue?vue&type=template&id=5c0ef85e&"
import script from "./products-edit.vue?vue&type=script&lang=js&"
export * from "./products-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports